import React, { useEffect, useState, useCallback, Fragment } from "react";
import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from '@react-google-maps/api';
import '../../assets/scss/styles.scss';

export const Map = ({contractors, user}) => {

    const [center, setCenter] = useState({
        lat: 36.1626638,
        lng: -86.7816016
    })

    useEffect(()=>{
        if (user) {
            setCenter({
                lat: user.lat,
                lng: user.long,
            })
        } else {
            setMap(null)
            setCenter({
                lat: 36.1626638,
                lng: -86.7816016
            })
        }
    }, [user])

    const containerStyle = {
        width: '100%',
        height: '750px'
    }
    
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_MAPS_API_KEY,
      })
    
    const [map, setMap] = useState(null)
    const [selectedPlace, setSelectedPlace] = useState(null);
    const [infoOpen, setInfoOpen] = useState(false);

    const markerClickHandler = (location, place) => {
        // Remember which place was clicked
        setSelectedPlace(place);
    
        // Required so clicking a 2nd marker works as expected
        if (infoOpen) {
          setInfoOpen(false);
        }

        setInfoOpen(true);
    }
    
    const onLoad = useCallback(function callback(map) {
        setMap(map)
    }, [])
    
    const onUnmount = useCallback(function callback(map) {
        setMap(null)
    }, [])


    return (
        isLoaded ? (
            <Fragment>
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={center}
              zoom={10}
              onLoad={onLoad}
              onUnmount={onUnmount}
            >
                {
                contractors.map(c => (
                    <Marker 
                     position={{lat: parseFloat(c.address1_latitude), lng: parseFloat(c.address1_longitude)}}
                     key={c.Id}
                     onClick={location => markerClickHandler(location, c)}
                    />
                ))
                }

                {infoOpen && selectedPlace && (
                    <InfoWindow
                    position={{lat: parseFloat(selectedPlace.address1_latitude), lng: parseFloat(selectedPlace.address1_longitude)}}
                    onCloseClick={() => setInfoOpen(false)}>
                    <div className="pin-content">
                        <h3>{selectedPlace.company_name}</h3>
                        <br/>
                        <p>
                        {selectedPlace.address1_street1}, {selectedPlace.address1_city},{" "}
                        {selectedPlace.address1_state} {selectedPlace.address1_zip}
                        </p>
                        <br/>
                    </div>
                    </InfoWindow>)}
            </GoogleMap>
            </Fragment>
        ) : <></>
    )
}
